<template>
  <div ref="containerRef" class="animacion-elegante">
    <!-- Foto principal a todo lo ancho -->
    <img
      ref="fotoRef"
      src="@/assets/Aliyah_Portraits-73.webp"
      alt="Foto destacada"
      class="foto-elegante-full"
    />

    <!-- Foto secundaria con inclinación opueeesta -->
  
  </div>
</template>
<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'AnimacionFotoPrincipal',
  setup() {
    const containerRef = ref(null)
    const fotoRef = ref(null)

    const animate = () => {
      const tl = gsap.timeline()

      // ✨ EFECTO HOJA: entra desde la izquierda, gira y se acomoda
      tl.fromTo(
        fotoRef.value,
        {
          x: -200,          // viene desde la izquierda
          opacity: 0,
          rotateY: -25,      // ligera torsión como hoja
          rotateZ: -4,
          scale: 0.95,
          filter: 'blur(6px)'
        },
        {
          x: 0,
          opacity: 1,
          rotateY: 0,
          rotateZ: 0,
          scale: 1,
          filter: 'blur(0px)',
          duration: 1.4,
          ease: 'power3.out'
        }
      )

      // ✨ Pequeño rebote suave
      tl.to(fotoRef.value, {
        y: -6,
        duration: 0.6,
        ease: 'sine.out'
      }).to(fotoRef.value, {
        y: 0,
        duration: 0.6,
        ease: 'sine.in'
      })
    }

    onMounted(() => {
      const observer = new IntersectionObserver(([entry], obs) => {
        if (entry.isIntersecting) {
          animate()
          obs.unobserve(entry.target)
        }
      }, { threshold: 0.2 })

      if (containerRef.value) observer.observe(containerRef.value)
    })

    return {
      containerRef,
      fotoRef
    }
  }
}
</script>


<style scoped>
.foto-elegante-full {

  transform-origin: left center; /* para que el giro sea elegante */
  backface-visibility: hidden;   /* hace más suave la animación 3D */
}

.animacion-elegante {
  position: relative;
  background: #e793b6;

  width: 100%;
    visibility: visible;
top:-20px;
  padding: 0px 0;
  display: flex;
  margin-top:-80px;

  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.foto-elegante-full {
  width: 100%;
  max-width: 100%;
  margin-bottom: 40px;
  opacity: 0;
}

.foto-elegante-reversa {
  width: 90%;
  max-width: 600px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.25);
  transform: rotate(3deg);
  opacity: 0;
}
</style>
